<template>
	<div class="plan-wrap">

		<el-row class="base-wrap" :gutter="40">
			<el-col :span="10">
				<div class="calendar">
					<div class="cale-header">
						<span v-text="calendar.year + '年'"></span>
						<div class="page"><i class="el-icon-caret-left" @click="showCalendarMonth(-1)"></i><span
								v-text="calendar.month + '月'"></span><i class="el-icon-caret-right"
								@click="showCalendarMonth(1)"></i></div>
					</div>
					<div class="row caption">
						<div class="day">周一</div>
						<div class="day">周二</div>
						<div class="day">周三</div>
						<div class="day">周四</div>
						<div class="day">周五</div>
						<div class="day">周六</div>
						<div class="day">周日</div>
					</div>
					<div class="row">
						<template v-for="(item, idx) in calendar.days">
							<div class="day"
								:class="{ same: item.sameMonth, visit: item.isVisit, visited: item.isVisited, today: item.isToday }"
								:key="idx" @click="showCalendarDay(item)" v-if="item.sameMonth">
								<span v-text="item.day"></span>
							</div>
							<div class="day" :key="idx" v-else><span v-text="item.day"></span></div>
						</template>

					</div>
					<div class="legend"><span class="l1">已随访</span><span class="l2">未随访</span></div>
				</div>

			</el-col>
			<el-col class="visit-info" :span="14">
				<div class="no-data" v-if="followIds.length == 0">此日无随访数据</div>

				<template v-else>
					<div class="visit-header">
						<span>就诊信息</span>
						<!-- <el-button size="small" round>查看就诊记录</el-button> -->
						<router-link class="round" target="_blank"
							:to="{ name: 'Patient/User', query: { patientId: patientId, t: 3, fid: itemRecord.id, datasources: itemRecord.datasources } }">查看就诊记录</router-link>
						<!--<div class="page"><i class="el-icon-caret-left" @click="showPage(-1)"></i><span>{{current+1}}/{{followIds.length}}</span><i class="el-icon-caret-right" @click="showPage(1)"></i></div>-->
					</div>
					<el-row>
						<el-col :span="12">来源: <span v-text="itemRecord.source"></span></el-col>
						<el-col :span="12">就诊科室：<span>{{ itemRecord.department }}</span></el-col>
					</el-row>
					<el-row>
						<el-col :span="12">住院号：<span>{{ itemRecord.admissionNumber }}</span></el-col>
						<el-col :span="12">离院方式：<span >{{ itemRecord.outhospitalType }}</span></el-col>
					</el-row>
					<el-row>
						<el-col :span="12">入院时间：<span>{{ itemRecord.inHospitalTime }}</span>
						</el-col>
						<el-col :span="12">出院时间：<span>{{itemRecord.outHospitalTime}}</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">住院次数：<span>{{ itemRecord.hospitalizationTimes }}</span></el-col>
						<el-col :span="12">住院天数：<span>{{ itemRecord.inhospitalDays }}</span></el-col>
					</el-row>
					<el-row>
						<el-col :span="12">责任医师：<span>{{ itemRecord.mainDoctor }}</span></el-col>
						<el-col :span="12">入院方式：<span>{{ itemRecord.inHospitalType }}</span></el-col>
					</el-row>
					<el-row>
						<el-col :span="12">电子病历：<a class="round" :href="itemRecord.emrUrl" target="_blank"><i
									class="icon-research"></i> 查看</a></el-col>
						<el-col :span="12" v-if="emrUrl1.flag && itemRecord.emrUrl1">{{ emrUrl1.name }}：<a class="round"
								:href="itemRecord.emrUrl1" target="_blank"><i class="icon-research"></i> 查看</a></el-col>
					</el-row>
					<el-row>
						<el-col :span="24" style="padding-bottom: 5px">{{ itemRecord.source }}诊断：
							<el-tag class="round" size="mini" type="danger"
								v-for="item in itemRecord.diagnosisTags" :key="item.tagId">{{item.tagName}}</el-tag>
						</el-col>
						<el-col :span="24">{{ itemRecord.diagnosisName }}</el-col>
					</el-row>
					<el-row>
						<el-col :span="24" style="padding-bottom: 5px;" v-if="itemRecord.surgeryName">手术：
							<el-tag class="round" size="mini" type="danger" v-for="item in itemRecord.surgeryTags" :key="item.tagId">{{ item.tagName }}</el-tag>
						</el-col>
						<el-col :span="24">{{ itemRecord.surgeryName }}</el-col>
					</el-row>
				</template>

			</el-col>
		</el-row>
		<div class="tag_main" v-show="followIds.length > 1">
			<el-row class="tag">
				<el-col :span="18" class="color-red text">
					<el-col :span="1">
						<i class="el-icon-warning text_1"></i>
					</el-col>
					<el-col :span="19"><span>当日有多条随访，可切换查看</span></el-col>
				</el-col>
				<el-col :span="6" class="color-red text_2">
					<div>
						<el-button class="color-red" type="text" size="mini" @click="showPage(1, -1)"
							icon="el-icon-arrow-left">上一条</el-button>
						<span style="padding:0 10px">{{ current + 1 }}/{{ followIds.length }}</span>
						<el-button class="color-red" type="text" size="mini" @click="showPage(1, 1)">下一条<i
								class="el-icon-arrow-right el-icon--right"></i></el-button>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-card class="follow-info" v-if="followIds.length > 0">
			<div slot="header" class="el-card-header">
				<span>应随访日期: {{ itemAdvice.expectFollowupDate }}</span>
				<div class="more">
					<el-button v-show="beforeFollowupRecordVO != null" class="color-red" type="text" size="mini"
						@click="showPage(2, -1)" icon="el-icon-arrow-left">上一条</el-button>
					<span>随访次数：{{ itemAdvice.followupNum }}</span>
					<el-button v-show="afterFollowupRecordVO != null" class="color-red" type="text" size="mini"
						@click="showPage(2, 1)">下一条<i class="el-icon-arrow-right el-icon--right"></i></el-button>
					<span v-if="itemAdvice.followupState == 1">随访状态：待随访</span>
					<span v-if="itemAdvice.followupState == 2">随访状态：已随访</span>
					<span v-if="itemAdvice.followupState == 3">随访状态：暂存</span>
					<span v-if="itemAdvice.followupState == 4">随访状态：终止随访</span>
				</div>
			</div>

			<el-alert class="errorTips" :closable="false" v-if="this.isNotFollow" type="warning" center show-icon>
				<span>
					当前随访无法完成，请先完成{{ isNotFollow }}随访计划
				</span>
				<router-link class="noline" target="_blank"
					:to="{ name: 'Patient/User', query: { patientId: patientId, t: 5, date: isNotFollow, datasources: itemRecord.datasources } }">立即前往>></router-link>
			</el-alert>
			<div class="el-card-main">
				<div class="item" v-if="itemAdvice.carefulVisit != 0">
					<div class="lbl">慎访原因</div>
					<div class="content" style="color: #FAAE10" v-text="itemAdvice.carefulVisitReason"></div>
				</div>
				<el-divider v-if="itemAdvice.carefulVisit != 0"></el-divider>
				<div class="item">
					<div class="lbl">随访建议</div>
					<div class="content" v-text="itemAdvice.followupAdvice"></div>
				</div>
				<el-divider></el-divider>
				<div class="item">
					<div class="lbl">六大处方</div>
					<table class="table_t table_t_auto">
						<tr>
							<td class="topic">用药处方</td>
							<td>
								<span class="table_text"
									v-show="prescriptionItem.hospitalMedicineVO.state == null">未制定</span>
								<el-tooltip class="item" effect="dark" content="查看" placement="top">
									<el-button v-show="prescriptionItem.hospitalMedicineVO.state == 1" type="text"
										@click="showPrescription(1)"><i class="icon-research" style="font-size:20px"></i>
									</el-button>
								</el-tooltip>
							</td>
							<td class="topic">饮食处方</td>
							<td>
								<span class="table_text" v-show="prescriptionItem.hospitalFoodVO.state == null">未制定</span>
								<el-tooltip class="item" v-show="prescriptionItem.hospitalFoodVO.state == 1" effect="dark"
									content="查看" placement="top">
									<el-button type="text" @click="showPrescription(2)"><i class="icon-research"
											style="font-size:20px"></i></el-button>
								</el-tooltip>
							</td>
							<td class="topic">运动处方</td>
							<td>
								<span class="table_text" v-show="prescriptionItem.hospitalSportVO.state == null">未制定</span>
								<el-tooltip class="item" effect="dark" content="查看" placement="top">
									<el-button v-show="prescriptionItem.hospitalSportVO.state == 1" type="text"
										@click="showPrescription(3)"><i class="icon-research"
											style="font-size:20px"></i></el-button>
								</el-tooltip>
							</td>
						</tr>
						<tr>
							<td class="topic">心理处方</td>
							<td>
								<span class="table_text"
									v-show="prescriptionItem.hospitalPsychologicalVO.state == null">未制定</span>
								<el-tooltip class="item" v-show="prescriptionItem.hospitalPsychologicalVO.state == 1"
									effect="dark" content="查看" placement="top">
									<el-button type="text" @click="showPrescription(4)"><i class="icon-research"
											style="font-size:20px"></i></el-button>
								</el-tooltip>
							</td>
							<td class="topic">睡眠处方</td>
							<td>
								<span class="table_text" v-show="prescriptionItem.hospitalSleepVO.state == null">未制定</span>
								<el-tooltip class="item" effect="dark" content="查看" placement="top">
									<el-button v-show="prescriptionItem.hospitalSleepVO.state == 1" type="text"
										@click="showPrescription(5)"><i class="icon-research"
											style="font-size:20px"></i></el-button>
								</el-tooltip>
							</td>
							<td class="topic">中医处方</td>
							<td>
								<span class="table_text"
									v-show="prescriptionItem.hospitalChineseMedicineVO.state == null">未制定</span>
								<el-tooltip class="item" v-show="prescriptionItem.hospitalChineseMedicineVO.state == 1"
									effect="dark" content="查看" placement="top">
									<el-button type="text" @click="showPrescription(6)"><i class="icon-research"
											style="font-size:20px"></i></el-button>
								</el-tooltip>
							</td>
						</tr>
					</table>
				</div>
				<div class="item" v-if="specialList.data != null && specialList.data.length > 0">
					<el-divider></el-divider>
					<div class="lbl">专项管理</div>
					<table class="table_t table_t_auto">
						<thead>
							<tr>
								<td class="topic">专项管理</td>
								<td class="topic">管理周期</td>
								<td class="topic">创建人</td>
								<td class="topic">更新时间</td>
								<td class="topic" style="width: auto;">操作</td>
							</tr>
						</thead>
						<tbody>
							<tr v-if="specialList.data == null || specialList.data.length == 0">
								<td colspan="5" style="text-align: center;">无数据</td>
							</tr>

							<tr v-for="(item, index) in specialList.data" v-bind:key="index">
								<td style="width: auto;">{{ item.name }}</td>
								<td style="width: auto;">
									<span v-if="!item.startTime || !item.endTime" class="table_text">未设置</span>
									<span v-else
										v-text="`${dateFormat(item.startTime)} 至 ${dateFormat(item.endTime)}`"></span>
								</td>
								<td style="width: auto;">{{ item.creatorName }}</td>
								<td style="width: auto;">{{ item.updateTime }}</td>
								<td style="width: auto;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text" @click="showSpecial(item.id)"><i class="icon-research"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
						</tbody>
					</table>
				</div>


				<el-divider
					v-if="itemAdvice.followupAppointmentReturnVisitDetailVOs && itemAdvice.followupAppointmentReturnVisitDetailVOs.length > 0">
				</el-divider>
				<div class="item" style="font-size: 16px;">
					复诊计划
				</div>
				<tab3 v-if="itemRecord.id" ref="info_t3" :recordId="itemRecord.id" :datasources="datasources"></tab3>
			</div>
		</el-card>

		<el-card class="follow-form" v-if="followIds.length > 0 && !isNotFollow">
			<div slot="header" class="el-card-header">
				<span>随访记录</span>
				<div class="more" v-if="form.state > 1">
					<span style="padding-right: 30px;">记录人:{{form.diseaseManager}}</span>
					<span>记录时间:{{form.updateTime}}</span>
					<span style="margin:0 10px;" v-if="form.followupType==4&&form.pushStatus!=0">推送时间:{{form.pushTime}}</span>
				</div>
			</div>
			<div class="el-card-main">
				<el-form ref="form" label-width="100px" :rules="dlg.rules" :model="form" v-if="form.state == 2">
					<el-form-item label="有效随访">{{ form.valid == 1 ? '是' : '否' }}</el-form-item>
					<el-divider></el-divider>
					<template v-if="form.valid == 1">
						<el-form-item label="随访方式">
							<span v-if="form.followupType == 1">电话</span>
							<span v-if="form.followupType == 2">短信</span>
							<span v-if="form.followupType == 3">来访</span>
						</el-form-item>
						<el-divider></el-divider>
						<!-- <template v-if="form.questionnaireFollowupListVOS.length > 0">
							<el-form-item label="随访问卷">
								<el-button size="mini" round
									@click="showQuest(form.questionnaireFollowupListVOS[0].dictId)"><i
										class="icon-research"></i> 查看问卷</el-button>
							</el-form-item>
							<el-divider></el-divider>
						</template> -->

						<el-row style="margin: 0 20px;" v-show="form.questionnaires.length > 0">
							<table class="table_t table_t_auto">
								<thead>
									<tr>
										<td class="topic">问卷名称</td>
										<td class="topic">填写时间</td>
										<td class="topic" style="width: auto;">操作</td>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in form.questionnaires" v-bind:key="index">
										<td style="width: auto;">{{ item.name }}</td>
										<td style="width: auto;">{{ item.finishTime == null ? '未填写' : item.finishTime }}</td>
										<td style="width: auto;">
											<el-tooltip class="item" effect="dark" content="查看">
												<el-button type="text" style="margin-right: 10px;"
													@click="openQue(item.id)"><i class="icon-research"
														style="font-size:20px"></i></el-button>
											</el-tooltip>
											<el-popconfirm confirmButtonText='删除' title="确定删除吗？"
												@confirm="delQuest(item.id)" v-show="item.finishTime == null">
												<el-tooltip slot="reference" class="item" effect="dark" content="删除">
													<el-button type="text"><i class="el-icon-delete"
															style="font-size:20px"></i></el-button>
												</el-tooltip>
											</el-popconfirm>
										</td>
									</tr>
								</tbody>
							</table>
							<el-divider></el-divider>
						</el-row>


						<template v-if="form.patientQuestion == 1">
							<el-form-item label="患者问题" style="margin-bottom: 0px;"></el-form-item>
							<el-form-item class="content-pre-wrap" label="问题" style="margin-bottom: 0px;">
								{{ form.patientQuestionContent }}
							</el-form-item>
							<el-form-item class="content-pre-wrap" label="解决与处理">{{ form.patientQuestionSolution }}
							</el-form-item>
							<el-divider></el-divider>
						</template>
						<template v-else>
							<el-form-item label="患者问题" style="margin-bottom: 0px;">无</el-form-item>
							<el-divider></el-divider>
						</template>

						<el-form-item class="content-pre-wrap" label="备注" prop="remark">{{ form.remark }}</el-form-item>
						<!-- <el-form-item label="满意度调查" v-if="form.questionnaireSatisfaction.length > 0">
							<el-button size="mini" round @click="showQuest(3)"><i class="icon-research"></i> 查看问卷
							</el-button>
						</el-form-item> -->
					</template>



					<template v-else>
						<el-form-item label="无效原因">
							<span v-if="form.notValidReason == 1">未接</span>
							<span v-if="form.notValidReason == 2">关机</span>
							<span v-if="form.notValidReason == 3">电话不通</span>
							<span v-if="form.notValidReason == 4">长时间超过10次无人接听</span>
							<span v-if="form.notValidReason == 5">停机</span>
							<span v-if="form.notValidReason == 6">空号</span>
							<span v-if="form.notValidReason == 7">错号</span>
							<span v-if="form.notValidReason == 8">拒接</span>
							<span v-if="form.notValidReason == 9">修改号</span>
							<span v-if="form.notValidReason == 10" v-text="form.notValidOtherReason"></span>
						</el-form-item>
						<el-form-item class="content-pre-wrap" label="备注" prop="remark">{{ form.remark }}</el-form-item>
					</template>
				</el-form>


				<el-form ref="form" label-width="100px" :rules="dlg.rules" :model="form"
					v-if="form.state == 1 || form.state == 3">
					<el-form-item label="有效随访" prop="valid">
						<el-radio-group v-model="form.valid" @change="clearFormValidate">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="form.valid == 1">
						<el-form-item label="随访方式" prop="followupType">
							<el-radio-group v-model="form.followupType">
								<el-radio :label="1">电话</el-radio>
								<el-radio :label="2">短信</el-radio>
								<el-radio :label="3">来访</el-radio>
								<el-radio :label="4" v-if="patient.wxBindingState==1">小程序</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="随访问卷">
							<!-- <el-button size="mini" round @click="showQuest(form.questionnaireFollowupListVOS[0].dictId)"><i class="icon-research"></i> 查看问卷</el-button> -->
							<el-button type="primary" plain @click="openQuestionnaire()">新增问卷</el-button>
						</el-form-item>

						<el-row style="margin: 0 20px;">
							<table class="table_t table_t_auto" v-show="form.questionnaires.length > 0">
								<thead>
									<tr>
										<td class="topic">问卷名称</td>
										<td class="topic">填写时间</td>
										<td class="topic" style="width: auto;">操作</td>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in form.questionnaires" v-bind:key="index">
										<td style="width: auto;">{{ item.name }}</td>
										<td style="width: auto;">{{ item.finishTime == null ? '未填写' : item.finishTime }}</td>
										<td style="width: auto;">
											<el-tooltip class="item" effect="dark" content="查看">
												<el-button type="text" style="margin-right: 10px;"
													@click="openQue(item.id)"><i class="icon-research"
														style="font-size:20px"></i></el-button>
											</el-tooltip>
											<el-tooltip class="item" effect="dark" content="发短信">
												<el-button type="text" v-if="hospitalCode == 'YS_HM4' || hospitalCode == 'SD_TA2'|| hospitalCode == 'AH_FY1'||hospitalCode=='SD_LY1'"
													style="margin-right: 10px; margin-left:0;" @click="showDlg(5, item)">
													<i class="icon-msg" style="font-size:20px; margin-left:0;"></i>
												</el-button>
											</el-tooltip>
											<el-popconfirm confirmButtonText='删除' title="确定删除吗？"
												@confirm="delQuest(item.id)">
												<el-tooltip slot="reference" class="item" effect="dark" content="删除">
													<el-button type="text"><i class="el-icon-delete"
															style="font-size:20px"></i></el-button>
												</el-tooltip>
											</el-popconfirm>
										</td>
									</tr>
								</tbody>
							</table>
						</el-row>

						<el-form-item label="患者问题" prop="patientQuestion" v-if="form.followupType!=4">
							<el-radio-group v-model="form.patientQuestion">
								<el-radio :label="1">有</el-radio>
								<el-radio :label="0">无</el-radio>
							</el-radio-group>
						</el-form-item>
						<div style="margin-bottom: 20px; padding: 20px 0 0 0;background: #f9f9fb;overflow: hidden;"
							v-if="form.patientQuestion == 1">
							<el-form-item label="问题" prop="patientQuestionContent">
								<el-input size="mini" type="textarea" style="width: 80%" rows="5" resize="none"
									v-model="form.patientQuestionContent"></el-input>
							</el-form-item>
							<el-form-item label="解决与处理" prop="patientQuestionSolution">
								<el-input size="mini" type="textarea" style="width: 80%" rows="5" resize="none"
									v-model="form.patientQuestionSolution"></el-input>
							</el-form-item>
						</div>
						<el-form-item label="备注" prop="remark">
							<el-input size="mini" type="textarea" style="width: 80%" rows="5" resize="none"
								v-model="form.remark"></el-input>
						</el-form-item>
						<!-- <el-form-item label="满意度调查" v-if="form.questionnaireSatisfaction != null && form.questionnaireSatisfaction.length > 0">
							<el-button size="mini" round @click="showQuest(3)"><i class="icon-research"></i> 查看问卷
							</el-button>
						</el-form-item> -->
					</template>

					<template v-else>
						<el-form-item label="无效原因" prop="notValidReason">
							<el-radio-group v-model="form.notValidReason">
								<el-radio :label="1">未接</el-radio>
								<el-radio :label="2">关机</el-radio>
								<el-radio :label="3">电话不通</el-radio>
								<el-radio :label="4">长时间超过10次无人接听</el-radio>
								<el-radio :label="5">停机</el-radio>
								<el-radio :label="6">空号</el-radio>
								<el-radio :label="7">错号</el-radio>
								<el-radio :label="8">拒接</el-radio>
								<el-radio :label="9">修改号</el-radio>
								<el-radio :label="10">其他</el-radio>
								<el-input size="mini" placeholder="输入其他原因" v-model="form.notValidOtherReason"
									v-if="form.notValidReason == 10"></el-input>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input size="mini" type="textarea" style="width: 80%" rows="5" resize="none"
								v-model="form.remark"></el-input>
						</el-form-item>
					</template>
					<div class="action">
						<template v-if="form.followupType==4&&itemAdvice.followupState==1">
							<el-button type="primary" :loading="isLoading" @click="showPushdlg">推送随访计划</el-button>
						</template>   
						<template v-else>
							<el-button type="primary" plain style="padding: 12px 20px;" :loading="isLoading" @click="saveForm(3)">暂 存</el-button>
							<el-button type="primary" :loading="isLoading" @click="showDlg(2)">保存并提交</el-button>
							<el-button type="danger" :loading="isLoading" @click="showDlg">终止随访</el-button>
						</template>
					</div>
				</el-form>

				<el-form ref="form" label-width="100px" v-if="form.state == 4">
					<el-form-item label="终止随访类型" style="margin-bottom: 0;">{{ form.stopType == 1 ? '单次终止' : '全部终止' }}
					</el-form-item>
					<el-form-item label="终止随访原因">{{ form.stopReason }}</el-form-item>
				</el-form>
			</div>
		</el-card>

		<el-dialog title="终止随访" width="560px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form2" label-width="120px" :rules="dlg.rules2" :model="form2">
				<el-form-item label="终止随访类型" prop="stopType">
					<el-radio-group v-model="form2.stopType">
						<el-radio :label="1">单次终止</el-radio>
						<el-radio :label="2">全部终止</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="终止随访原因" prop="stopReason">
					<el-radio-group v-model="form2.stopReason">
						<el-radio label="患者已住院">患者已住院</el-radio>
						<el-radio label="患者死亡">患者死亡</el-radio>
						<el-radio label="无法联系到患者">无法联系到患者</el-radio>
						<el-radio label="other">其他原因</el-radio>
						<el-input size="mini" placeholder="输入其他原因" style="width: 250px;" v-model="form2.otherReason"
							v-if="form2.stopReason == 'other'"></el-input>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm2">保 存</el-button>
			</div>
		</el-dialog>

		<el-dialog title="保存随访" width="560px" :visible.sync="dlg2.active" :close-on-click-modal="false">
			保存随访后<strong style="color: red;">不可修改</strong>，确认保存吗？
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg(2)">取 消</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm(2)">确认保存</el-button>
			</div>
		</el-dialog>


		<el-dialog title="发短信" label-position="left" width="800px" :visible.sync="dlg.active5"
			:close-on-click-modal="false">
			<el-form ref="form5" :rules="dlg.rules5" :model="form5">
				<el-form-item label="接收人:">
					<el-select placeholder="请选择接收人" v-model="form5.phoneIndex">
						<el-option v-for="(item, index) in phoneBook" :key="index" :label="item.info" :value="index" />
					</el-select>
				</el-form-item>
				<el-form-item label="" label-width="0" prop="content">
					<el-input type="textarea" style="width: 100%;" rows="6" resize="none" maxlength="255"
						placeholder="请输入短信内容,最多255个字" show-word-limit v-model="form5.content"></el-input>
					<div v-if="smsFlag">
						计费条数:&nbsp;{{ Math.ceil(form5.content.length / smsPrice) }}条&nbsp;&nbsp;({{ smsPrice }}字/条)</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg(5)">取 消</el-button>
				<el-button type="primary" @click="saveForm5()" v-if="!isLoading">发 送</el-button>
				<el-button type="primary" :loading="true" v-else>发送中</el-button>
			</div>
		</el-dialog>

		<temp1 :disabled="isQstDisabled" :item="form.questionnaireFollowupListVOS[0]" v-if="questActive == 1"
			@update="updateQuest" @close="closeQuest"></temp1>
		<temp2 :disabled="isQstDisabled" :item="form.questionnaireFollowupListVOS[0]" v-if="questActive == 2"
			@update="updateQuest" @close="closeQuest"></temp2>
		<temp3 :disabled="isQstDisabled" :item="form.questionnaireSatisfaction[0]" v-if="questActive == 3"
			@update="updateQuest" @close="closeQuest"></temp3>
		<temp4 :disabled="isQstDisabled" :item="form.questionnaireFollowupListVOS[0]" v-if="questActive == 7"
			@update="updateQuest" @close="closeQuest"></temp4>

		<el-drawer size="800px" :show-close="false" :visible="prescriptionActive.visible" @close="closePrescription">
			<template slot="title">
				<div class="el-drawer-close" @click="closePrescription"><i class="el-icon el-icon-arrow-left"></i>返回
				</div>
				<div>处方详情</div>
			</template>
			<div v-if="prescriptionActive.type == 1">
				<drug ref="drug" :patientId="patientId" :recordId="itemRecord.id" :itemDetail="prescriptionItem"
					:isShow="false" :medicalRecordDetail="medicalRecordDetail" :patientInfo='patient'></drug>
			</div>
			<div v-if="prescriptionActive.type == 2">
				<diet ref="diet" :patientId="patientId" :recordId="itemRecord.id" :itemDetail="prescriptionItem"
					:isShow="false" :medicalRecordDetail="medicalRecordDetail" :patientInfo='patient'></diet>
			</div>
			<div v-if="prescriptionActive.type == 3">
				<sports ref="sports" :patientId="patientId" :recordId="itemRecord.id" :itemDetail="prescriptionItem"
					:isShow="false" :medicalRecordDetail="medicalRecordDetail" :patientInfo='patient'></sports>
			</div>
			<div v-if="prescriptionActive.type == 4">
				<psychology ref="psychology" :patientId="patientId" :recordId="itemRecord.id" :itemDetail="prescriptionItem"
					:isShow="false" :medicalRecordDetail="medicalRecordDetail" :patientInfo='patient'>
				</psychology>
			</div>
			<div v-if="prescriptionActive.type == 5">
				<sleep ref="sleep" :patientId="patientId" :recordId="itemRecord.id" :itemDetail="prescriptionItem"
					:isShow="false" :medicalRecordDetail="medicalRecordDetail" :patientInfo='patient'></sleep>
			</div>
			<div v-if="prescriptionActive.type == 6">
				<medicine ref="medicine" :patientId="patientId" :recordId="itemRecord.id" :itemDetail="prescriptionItem"
					:isShow="false" :medicalRecordDetail="medicalRecordDetail" :patientInfo='patient'></medicine>
			</div>
		</el-drawer>

		<!-- <el-drawer size="800px" :show-close="false" :visible="specialActive.visible">
			<template slot="title">
				<div class="el-drawer-close" @click="closeSpecial"><i class="el-icon el-icon-arrow-left"></i>返回</div>
				<div>专项管理详情</div>
			</template>
			<ViewDetail :patientId="patientId" :model.sync="specialItem" />
		</el-drawer> -->

		<questionnaire :recordId="Number(followId)" :customerId="customerId" :patientId="patientId" :recordType="0"
			:visible="questionnaireType" @close="closeQuestionnaire" :writeQuestionnaire.sync="writeQuestionnaire">
		</questionnaire>

		<el-dialog title="推送随访计划" width="800px" :visible.sync="pushDlg.active" :close-on-click-modal="false" class="cenDialog">
			<p style="text-align:center">{{ pushDlg.text }}</p>
			<p style="text-align:center">推送成功后，患者将在双佰康小程序中收到提醒</p>
			<div slot="footer" class="dialog-footer cenFooter">
				<el-button type="primary" @click="pushFollowup">确定推送</el-button>
				<el-button @click="closeDlg(6)">取 消</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

import Temp1 from './template/template-1.vue';
import Temp2 from './template/template-2.vue';
import Temp3 from './template/template-3.vue';
import Temp4 from './template/template-4.vue';
import Questionnaire from './questionnaire/questionnaire.vue';

import Diet from './prescription/diet.vue';
import Drug from './prescription/drug.vue';
import Medicine from './prescription/medicine.vue';
import Psychology from './prescription/psychology.vue';
import Sleep from './prescription/sleep.vue';
import Sports from './prescription/sports.vue';
//import ViewDetail from './special/view.vue';
import Tab3 from './user-followup-3.vue';
import {
	EventBus
} from '@/event-bus.js';
import { Loading } from 'element-ui';

export default {
	components: {
		Temp1,
		Temp2,
		Temp3,
		Temp4,
		Questionnaire,
		Diet,
		Drug,
		Medicine,
		Psychology,
		Sleep,
		Sports,
		Tab3
		//ViewDetail
	},
	mixins: [mixin],
	props: {
		onEvalShow: {
			type: Function,
			default: null
		},
		customerId: Number,
		smsFlag: Boolean,
		smsPrice: Number,
		patient: {
			default: null
		}
	},
	watch: {
		$route() {
			if (this.$route.query.t == 5) {
				this.init();
			}
		}
	},
	data() {
		return {
			prescriptionActive: {
				type: 0,
				visible: false
			},
			specialActive: {
				visible: false
			},
			specialItem: undefined,
			noSidebar: true,
			dlg: {
				active: false,
				// 发短信
				active5: false,
				rules: {
					valid: {
						required: true,
						message: '请选择'
					},
					notValidReason: {
						required: true,
						message: '请选择'
					},
					followupType: {
						required: true,
						message: '请选择'
					},
					patientQuestion: {
						required: true,
						message: '请选择'
					},
					patientQuestionContent: {
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					},
					patientQuestionSolution: {
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}
				},
				rules2: {
					stopType: {
						required: true,
						message: '请选择'
					},
					stopReason: {
						required: true,
						message: '请选择'
					},
				}
			},
			dlg2: {
				active: false,
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			specialList: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			form: {
				id: 0,
				valid: '',
				followupType: '',
				patientQuestion: '',
				patientQuestionContent: '',
				patientQuestionSolution: '',
				remark: '',
				notValidReason: '',
				notValidOtherReason: '',
				state: 0,
			},
			form2: {
				id: 0,
				stopType: '',
				stopReason: '',
				otherReason: ''
			},
			// 短信表单
			form5: {
				content: '',
				shortMessageSendListPos: [],
				phoneIndex: 0
			},
			calendar: {
				viewMonth: '', // 查看的月份
				today: '',
				year: '',
				month: '',
				days: [],
			},
			questionnaireType: false,
			//customerId: 0,
			patientId: 0,
			recordId: 0,
			followId: 0,
			followDays: [], // 当月有 随访记录 的日期
			followIds: [], // 保存当前的 随访记录id
			followList: {}, // 当天 随访记录 数据
			current: 0,
			itemRecord: '',
			itemAdvice: '',
			questActive: 0,
			isQstDisabled: false, // 禁用 问卷 修改功能
			prescriptionItem: {
				hospitalChineseMedicineVO: {
					state: null
				},
				hospitalFoodVO: {
					state: null
				},
				hospitalMedicineVO: {
					state: null
				},
				hospitalPsychologicalVO: {
					state: null
				},
				hospitalSleepVO: {
					state: null
				},
				hospitalSportVO: {
					state: null
				}
			},
			my: undefined, // 当前登录用户信息
			writeQuestionnaire: false, //是否填写问卷
			medicalRecordDetail: {}, //科室床号
			hospitalCode: 'YS_HM4',
			changeFlag: false, //月份切换
			beforeFollowupRecordVO: {}, //之前的随访数据
			afterFollowupRecordVO: {}, //之后的随访数据
			isNotFollow: '', //是否在当前日之前有未随访或暂存的随访数据
			emrUrl1: {}, //第二个电子病历
			phoneBook: [], // 患者电话本
			dataId: '',
			pushDlg:{
					active:false,
					text:''
				}
		}
	},
	created() {
		this.init();
	},
	mounted() {
		let query = this.$route.query;
		this.dataId = query.followupId;
		// 监听页面显示隐藏
		document.addEventListener('visibilitychange', this.handleVisiable)
	},
	destroyed() {
		document.removeEventListener('visibilitychange', this.handleVisiable);
		this.writeQuestionnaire = false;
	},
	methods: {
		async init() {
			this.my = JSON.parse(localStorage.getItem('user')).data;
			// this.datasources = +this.$route.query.datasources;
			this.patientId = +this.$route.query.patientId;
			if (!this.$route.query.date) {
				this.calendar.today = dayjs();
			} else {
				this.calendar.today = dayjs(this.$route.query.date);
			}
			if (this.$route.query.current && +this.$route.query.current > 0) {
				this.current = (+this.$route.query.current - 1) || 0;
			}
			this.calendar.viewMonth = this.calendar.today;
			this.hospitalCode = await api.getHospitalCode();
			this.emrUrl1 = await api.getemrUrl1();
			this.loadList();
			this.loadSpecialList();
			
		},
		showPushdlg(){
			this.pushDlg.active=true
			if(this.form.questionnaires.length>0){
				this.pushDlg.text='确定将相关随访内容推送至双佰康小程序？'
			}else{
				this.pushDlg.text='随访内容中未添加随访问卷，确定推送至双佰康小程序？'
			}
		},
		pushFollowup(){
				api.pushFollowupData({
					id:this.followId,
					valid:this.form.valid,
					followupType:this.form.followupType,
					remark:this.form.remark,
				}).then(res=>{
					if(res.code==1000){
						this.$message.success('推送成功');
					}
					this.pushDlg.active=false;
					this.pushDlg.text='';
					this.init();
					this.writeQuestionnaire = false;
					localStorage.setItem('save', JSON.stringify('saved'));

				})
		},
		// 获取指定日期下相关的 随访数据id
		async loadList() {
			this.isLoading = true;
			let res = await api.getFollowListByDate({
				patientId: this.patientId,
				queryDate: this.calendar.today.format('YYYY-MM-DD')
			});
			if (res.code == 500) {
				return this.$router.push({
					name: 'Login',
					query: {
						r: location.href
					}
				});
			}
			this.followDays = res.data.followupDateStateVOS;
			if (res.data.followupIds && res.data.followupIds.length > 0) {
				this.followIds = res.data.followupIds;
				this.followList = {};

				if (this.current >= this.followIds.length) {
					this.current = this.followIds.length - 1;
				}
				if (this.$route.query.followupId && +this.$route.query.followupId > 0 && !this.changeFlag) {
					this.current = this.followIds.indexOf(+this.$route.query.followupId);
				}

				if (this.dataId) {
					await this.getData(this.dataId);//解决当天两条随访记录问题
				} else {
					await this.getData(this.followIds[this.current]);

				}

			}

			this.createCalendar();
			this.isLoading = false;
		},
		async loadSpecialList() {
			this.isLoading = true;
			let res = await api.getPatientSpecialList({
				patientId: this.patientId,
				pageNumber: 1,
				pageSize: 9999999,
			});
			if (res.code == 500) {
				return this.$router.push({
					name: 'Login',
					query: {
						r: location.href
					}
				});
			}

			//this.specialList.total = +res.total;
			//this.specialList.current = this.filter.pageNumber;
			//this.specialList.pageSize = Math.ceil(this.specialList.total / this.filter.pageSize);
			if (res.data) {
				this.specialList.data = res.data;
			}
			this.isLoading = false;
		},
		// 获取单个 随访记录 相关数据
		async getData(id) {
			this.followId = id;
			if (this.followList[this.current]) {
				// 缓存数据
				this.itemRthis.followListecord = this.followList[this.current].medicalRecordDetialVO;
				this.itemAdvice = this.followList[this.current].followupStateDetailVO;

				this.form = this.followList[this.current].followupRecordVO;
				if (this.hospitalCode == 'FJ_SM1' && window.location.hostname == "jbglxt.smdyyy.cn") {
					this.itemRecord.emrUrl =
						`http://jbglxt.smdyyy.cn:30080/EmrView/?${this.itemRecord.emrUrl.split('?')[1]}`;
				}
			} else {
				let res = await api.getFollow({
					id: id
				});
				if (res.code == 1000) {
					this.datasources=+res.data.medicalRecordDetialVO.datasources;
					setTimeout(() => {
						this.getMedicalRecordDetail();
					}, 100);
					switch (+res.data.medicalRecordDetialVO.datasources) {
						case 0:
							res.data.medicalRecordDetialVO.source = '院中';
							break;
						case 1:
							res.data.medicalRecordDetialVO.source = '门诊';
							break;
						case 2:
							res.data.medicalRecordDetialVO.source = '出院';
							break;
					}
					res.data.followupStateDetailVO.expectFollowupDate = dayjs(res.data.followupStateDetailVO
						.expectFollowupDate).format('YYYY-MM-DD');
					if (res.data.followupRecordVO.questionnaireFollowupListVOS == null) {
						res.data.followupRecordVO.questionnaireFollowupListVOS = [];
					}
					if (res.data.followupRecordVO.questionnaireFollowupListVOS.length > 0) {
						// 问卷表单需要使用到
						res.data.followupRecordVO.questionnaireFollowupListVOS[0].patientId = this.patientId;
						res.data.followupRecordVO.questionnaireFollowupListVOS[0].dataId = id;
					}
					this.itemRecord = res.data.medicalRecordDetialVO;
					if (this.hospitalCode == 'FJ_SM1') {
						this.itemRecord.emrUrl =
							`http://jbglxt.smdyyy.cn:30080/EmrView/?${this.itemRecord.emrUrl.split('?')[1]}`;
					}
					this.itemAdvice = res.data.followupStateDetailVO;
					this.form = res.data.followupRecordVO;
					this.form.followupState = this.itemAdvice.followupState;
					this.followList[this.current] = res.data;
					this.beforeFollowupRecordVO = res.data.beforeFollowupRecordVO;
					this.afterFollowupRecordVO = res.data.afterFollowupRecordVO;
					this.prescription();
				}
				this.followupRecoreListHandle()

			}
			// 默认值
			this.form.id = id;
			// this.form.valid = this.form.valid || 1;
			/**
			 * valid 的值有 null, 0 无效,1 有效 
			 * 使用this.form.valid = this.form.valid || 1;的写法，会把null和0都改写成1
			 */
			this.form.valid = this.form.valid != null ? this.form.valid : 1;
			console.log(this.form.followupType, '======form.followupType');
			this.form.followupType = this.form.followupType || 1;
			this.form.patientQuestion = this.form.patientQuestion || 0;
			// 页面通用 '随访状态' 显示
			this.form.state = this.form.followupState;

			// 终止随访 用到
			this.form2.id = id;

			// 是否禁用 问卷 保存
			this.isQstDisabled = this.form.state == 2 || this.form.state == 4;

			// 调整日期显示格式
			this.itemAdvice.followupDate = dayjs(this.itemAdvice.followupDate).format('YYYY-MM-DD');
			if (this.itemAdvice.followupAppointmentReturnVisitDetailVOs) {
				this.itemAdvice.followupAppointmentReturnVisitDetailVOs.forEach((item) => {
					item.appointmentDate = dayjs(item.appointmentDate).format('YYYY-MM-DD');
				});
			}
			// 清除表单验证状态
			this.$nextTick(() => {
				this.clearFormValidate();
			});
		},
		// 判断随访状态
		followupRecoreListHandle() {
			if (this.beforeFollowupRecordVO && this.beforeFollowupRecordVO.followupState != 2 && this.beforeFollowupRecordVO.followupState != 4) {
				let expectDate = dayjs(this.beforeFollowupRecordVO.expectFollowupDate).format('YYYY-MM-DD');
				this.$message.error('此次随访前，有未完成的随访');
				this.isNotFollow = expectDate
			} else {
				this.isNotFollow = false
			}
		},
		// 获取六大处方数据
		async prescription() {
			this.isLoading = true;
			let res = await api.queryPrecription({
				customerId: this.customerId,
				recordId: this.itemRecord.id,
				datasources: this.itemRecord.datasources
			});
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.prescriptionItem = res.data;
		},
		// 获取就诊信息
		async getMedicalRecordDetail() {
			let result = await api.getFollowUp({
				recordId: this.itemRecord.id,
				datasources: this.datasources
			});
			if (result.code == 1000) {
				this.medicalRecordDetail = result.data;
			}
		},
		// 保存, 暂存
		async saveForm(v) {
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					this.isLoading = true;
					this.form.followupState = v;
					// this.form.followupState = 1;
					let res = await api.editFollow(this.form);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.closeDlg(2);
					this.init();
					this.writeQuestionnaire = false;

					let info = JSON.parse(localStorage.getItem('callerInfo'));
					let callstate = localStorage.getItem('callState');
					if (callstate == 'callIn') {
						let phoneRecordId = JSON.parse(localStorage.getItem('phoneRecordId'));
						// let info=JSON.parse(localStorage.getItem('callerInfo'));
						let res = await api.updatePatientRecord({
							phoneRecordId: phoneRecordId,
							patientId: this.patientId,
							phone: info.split(',')[0]
						})
					}


					let sta = JSON.parse(localStorage.getItem('callstatus'));
					let phoneRecordId = JSON.parse(localStorage.getItem('phoneRecordId'));
					if (phoneRecordId && sta == 'finished') {
						localStorage.removeItem('phoneRecordId')
					}
					localStorage.removeItem('callerInfo');
					localStorage.removeItem('callState');
					localStorage.setItem('save', JSON.stringify('saved'));
					EventBus.$emit('update-callstatus', 'normal');
					EventBus.$emit('update-phoneList-value', {
						phone: '',
						phoneList: []
					});
					// this.form.state = this.form.followupState;
					// this.itemAdvice.followupState = this.form.state;
				}
			});
		},
		// 终止随访
		async saveForm2() {
			this.$refs['form2'].validate(async (valid) => {
				if (valid) {
					let form = JSON.parse(JSON.stringify(this.form2));
					if (form.stopReason == 'other') {
						form.stopReason = form.otherReason;
					}
					if (form.stopReason == '') {
						return this.$message.warning('请输入终止原因')
					}
					this.isLoading = true;
					let res = await api.stopFollow(form);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.form.state = 4;
					this.form.stopType = form.stopType;
					this.form.stopReason = form.stopReason;
					this.itemAdvice.followupState = this.form.state;
					this.closeDlg();
					this.init();
				}
			})
		},
		clearFormValidate() {
			if (this.$refs['form']) {
				this.$refs['form'].clearValidate();
			}
		},
		showPrescription(type) {
			this.prescriptionActive.type = type;
			this.prescriptionActive.visible = true;
			this.$nextTick(() => {
				switch (type) {
					case 2:
						this.$refs.diet.init(this.prescriptionItem);
						break;
					case 3:
						this.$refs.sports.init(this.prescriptionItem);
						break;
					case 4:
						this.$refs.psychology.init(this.prescriptionItem);
						break;
					case 5:
						this.$refs.sleep.init(this.prescriptionItem);
						break;
					case 6:

						this.$refs.medicine.init(this.prescriptionItem);
						break;
					default:
						this.$refs.drug.init(this.prescriptionItem);
						break;
				}
			});

		},
		closePrescription() {
			this.prescriptionActive.type = 0;
			this.prescriptionActive.visible = false;
		},
		async showSpecial(id) {
			this.specialActive.visible = true;
			let res = await api.getPatientSpecial(id);
			if (res.code == 1000) {
				this.specialItem = res.data;
			}
			this.$emit('update:model', this.specialItem);
			this.$router.push({
				name: 'Patient/User',
				query: {
					patientId: this.patientId,
					t: 8,
					vid: id,
					datasources: this.itemRecord.datasources
				}
			});
		},
		closeSpecial() {
			this.specialActive.visible = false;
		},
		showDlg(v, qObj = null) {
			if (v == 5) {
				// 发问卷短信
				this.getPhoneBook();
				let token = JSON.parse(localStorage.getItem('user')).data.token;
				if (this.hospitalCode == 'SD_LY1') {
					this.form5.content = `您好，请填写《${qObj.name}》，谢谢！http://221.2.94.162:19003/${qObj.qcId}?rid=${qObj.id}`;
				} else if (this.hospitalCode == 'SD_TA2') {
					this.form5.content = `您好，请填写《${qObj.name}》，谢谢！https://q.taishanyy.com:19003/${qObj.qcId}?rid=${qObj.id}`;

				}else if(this.hospitalCode == 'AH_FY1'|| this.hospitalCode == 'YS_HM4'){
					this.form5.content = `您好，请填写《${qObj.name}》，谢谢！https://q.fysyy.com:19003/s/${qObj.qcId}/${qObj.id}`;
					console.log(this.form5.content,'-------vvvv')
				}
				this.dlg.active5 = true;
				if (this.smsFlag) {
					this.smsPrice = JSON.parse(localStorage.getItem('smsInfo'))?.smsPrice;
				}
				return;
			}
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					if (v == 2) {
						this.dlg2.active = true;
						return;
					}


					// 终止随访 弹窗
					this.dlg.active = true;
				}

			});
		},
		closeDlg(v) {
			switch(v) {
					case 2:
						this.dlg2.active = false;
					break;
					case 5:
						this.dlg.active5 = false;
						this.form5={
							content: '',
							shortMessageSendListPos: [],
							phoneIndex:0
						};
						break;
					case 6:
						this.pushDlg.active = false;
						this.pushDlg.text = '';
						break;
					default:
						this.dlg.active = false;
				}
				this.dlg.active = false;
			},
		// 问卷 显示
		showQuest(v) {
			this.questActive = v;
		},
		// 问卷 状态更新
		updateQuest(item) {
			console.log('更新问卷', item.dictId);
			if (item.dictId == 3) {
				// 满意度问卷
				this.followList[this.current].followupRecordVO.questionnaireSatisfaction[0].resultJson = JSON
					.stringify(item);
				this.form = this.followList[this.current].followupRecordVO;

			} else {
				this.followList[this.current].followupRecordVO.questionnaireFollowupListVOS[0].resultJson = JSON
					.stringify(item);
				this.form = this.followList[this.current].followupRecordVO;
			}
			this.closeQuest();
		},
		closeQuest() {
			this.questActive = 0;
		},
		
		showPage(v, p) {
			let loadingInstance = Loading.service({ fullscreen: true });
			if (v == 1) {
				if (p == 1) { //下一条记录
					if ((this.current + 1) < this.followIds.length) {
						this.current++;
						this.getData(this.followIds[this.current]);
					}
				} else { //上一条记录
					if ((this.current + 1) > 1) {
						this.current--;
						this.getData(this.followIds[this.current]);
					}
				}
				this.$router.push({
					name: 'Patient/User',
					query: {
						patientId: this.patientId,
						t: 5,
						date: this.calendar.today.format('YYYY-MM-DD'),
						current: this.current + 1,
						datasources: this.itemRecord.datasources
					}
				});

			} else if (v == 2) {
				let beforeDate = this.beforeFollowupRecordVO && dayjs(this.beforeFollowupRecordVO.expectFollowupDate).format('YYYY-MM-DD');
				let afterDate = this.afterFollowupRecordVO && dayjs(this.afterFollowupRecordVO.expectFollowupDate).format('YYYY-MM-DD');
				if (p == 1) { //下一条记录
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 5,
							date: afterDate,
							datasources: this.itemRecord.datasources
						},
						target: '_blank'
					})
				} else { //上一条记录
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 5,
							date: beforeDate,
							datasources: this.itemRecord.datasources
						},
						target: '_blank'
					})
				}
			}
			window.location.reload();
		},
		// 显示某天数据
		showCalendarDay(item) {
			if (item.isVisit || item.isVisited) {
				this.calendar.today = dayjs(item.date);
				this.current = 0;
				this.$router.push({
					name: 'Patient/User',
					query: {
						patientId: this.patientId,
						t: 5,
						date: this.calendar.today.format('YYYY-MM-DD'),
						datasources: this.itemRecord.datasources
					}
				});
				window.location.reload();
			}
			window.location.reload();

		},
		// 切换 月份
		showCalendarMonth(v) {
			this.changeFlag = true;
			this.calendar.viewMonth = this.calendar.viewMonth.add(v, 'month');
			this.calendar.today = dayjs();
			if (!this.calendar.viewMonth.isSame(this.calendar.today, 'month')) {
				this.calendar.today = this.calendar.viewMonth.set('date', 1);
			}
			// this.current = 0;
			this.loadList();
		},
		createCalendar() {
			let startDay;
			// let visited;
			let firstDay = this.calendar.viewMonth.startOf('month');
			let day = firstDay.day();
			let checkVisit = (curr) => {
				let followDays = this.followDays;
				// 验证当天是否有 随访记录
				if (followDays && followDays.length > 0) {
					for (let i = 0; i < followDays.length; i++) {
						if (dayjs(followDays[i].currentTime).isSame(curr, 'day')) {
							return {
								visit: followDays[i].state == 1,
								visited: followDays[i].state == 2
							};
						}
					}
				}
				return {
					visit: false,
					visited: false
				};
			}
			this.calendar.year = this.calendar.viewMonth.year();
			this.calendar.month = this.calendar.viewMonth.month() + 1;
			switch (day) {
				case 0:
					startDay = firstDay.add(-6, 'day');
					break;
				case 1:
					startDay = firstDay;
					break;
				default:
					startDay = firstDay.add((day - 1) * -1, 'day');
					break;
			}
			this.calendar.days = [];
			for (let i = 0; i < 42; i++) {
				let nextDay = startDay.add(i, 'day');
				let followResut = checkVisit(nextDay);
				this.calendar.days.push({
					date: nextDay.format('YYYY-MM-DD'),
					day: nextDay.date(),
					isToday: nextDay.isSame(this.calendar.today, 'day'),
					sameMonth: nextDay.month() == this.calendar.viewMonth.month(),
					isVisit: followResut.visit,
					isVisited: followResut.visited
				})
			}
		},
		openQuestionnaire() {
			this.questionnaireType = true;
			this.$nextTick(() => {
				this.recordId = this.itemRecord.id;
			})
		},
		closeQuestionnaire() {
			if (this.writeQuestionnaire && this.itemAdvice.followupState == 3) {
				this.saveForm(3);
			}
			this.questionnaireType = false;
			this.init();
		},
		async delQuest(id) {
			let res = await api.delQuestionnaireResult(id);
			if (res.code == 1000) {
				this.init();
				if (this.itemAdvice.followupState == 3) {
					this.saveForm(3);
				}
			}
		},
		async openQue(id) {
			let res = await api.getQuestResult({
				id: id
			});
			if (res.code == 1000) {
				let res1 = await api.getQuestiondictById(res.data.qcId);
				let questionnaireJson = JSON.parse(res1.data.questionnaireJson);
				const href = this.$router.resolve({
					path: '/qst/' + res.data.qcId,
					query: {
						rid: res.data.id,
						t: this.my.token,
					}
				})
				let openWin = window.open(href.href, "_blank");
				let loop = setInterval(() => {
					if (openWin.closed) {
						clearInterval(loop);
						this.init();
					}
				}, 1000);
			}

		},
		dateFormat(v) {
			return dayjs(v).format('YYYY-MM-DD');
		},
		handleVisiable(e) {
			// 关闭新开页面，回到列表页，刷新列表数据
			if (e.target.visibilityState == "visible") {
				this.closeQuestionnaire();
			}
		},
		async getPhoneBook() {
			let res = await api.getPhonebookList({ 'pid': this.patientId });
			if (res.code == 1000) {
				res.data.forEach(item => {
					item.info = `${item.name}(${item.relationshipName}):${item.phone}`
				})
				this.phoneBook = res.data;

				console.log(this.phoneBook)
			}
		},
		async saveForm5() {
			this.form5.shortMessageSendListPos = [{
				patientId: this.patientId,
				phone: this.phoneBook[this.form5.phoneIndex].phone,
			}]
			let res = await api.sendSMS(this.form5);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('短信发送成功');
			this.closeDlg(5);
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/common.less';
.plan-wrap {
	.errorTips {
		background: #FFECEC;
		padding: 12px 16px;
		width: 80%;
		margin: 0 auto;

		i {
			font-size: 16px;
			width: 16px;
			margin-top: 6px;
		}

		i,
		a {
			color: #FF5D5D;
		}

		a {
			font-size: 16px;
			margin-left: 40px;
		}

		span {
			color: #000;
			font-size: 14px;
		}
	}

	.base-wrap {
		margin-bottom: 20px;
		padding: 20px 30px;
		background: #fff;
		display: flex;
	}

	.tag_main {
		margin-bottom: 20px;

		.tag {
			border-radius: 5px;
			height: 35px;
			margin: 0 30px;
			padding: 0 15px;
			font-size: 13px;
			height: 60px;
		}

		.color-red {
			background-color: #fef0f0;
			color: #f56c6c;
		}

		.text {
			line-height: 60px;
			height: 60px;
			padding-left: 30px;
			font-size: 17px;
		}

		.text_1 {
			font-size: 23px;
			padding-top: 19px
		}

		.text_2 {
			line-height: 60px;
			text-align: right;
			padding-right: 30px;
			font-size: 17px;
		}
	}

	.table_t {
		border: 1px solid #A9A9A9;
		border-collapse: collapse;
		border-spacing: 0;
		text-align: center;
		font-size: 14px;
		color: #333333;
		width: 100%;
		margin-bottom: 20px;
	}

	.table_t th {
		height: 40px;
		border: 1px solid #A9A9A9;
	}

	.table_t td {
		height: 40px;
		line-height: 40px;
		border: 1px solid #A9A9A9;
		width: 25%;
	}

	.table_text {
		color: #F56C6C;
		font-size: 14px;
	}

	.table_t_auto td {
		width: auto;
	}

	.topic {
		background-color: #EBF4FF;
	}

	.calendar {
		position: relative;
		background: #fff;
		text-align: center;

		.cale-header {
			margin-bottom: 10px;
			padding-bottom: 10px;
			display: flex;
			justify-content: space-between;

			.page {
				i {
					padding: 0 5px;
					cursor: pointer;
				}
			}
		}

		.row {
			padding: 0 .3rem;
			color: #dfdfdf;
			display: flex;
			flex-wrap: wrap;
		}

		.row.caption {
			color: #999;
		}

		.day {
			position: relative;
			width: 14.285%;
			height: 50px;
			text-align: center;

			&::after {
				position: absolute;
				left: 50%;
				bottom: 14px;
				width: 8px;
				height: 8px;
				border-radius: 50%;
				content: '';
				transform: translate3d(-50%, 0, 0);
			}

			&.visit {
				cursor: pointer;

				&::after {
					background-color: #D63803;
				}
			}

			&.visited {
				cursor: pointer;

				&::after {
					background-color: #B8E986;
				}
			}

			&.today {
				span {
					background: #699ce4;
					color: #fff;
				}
			}

			&.same {
				color: #555;
			}

			span {
				width: 26px;
				height: 26px;
				line-height: 26px;
				;
				border-radius: 50%;
				font-size: 12px;
				display: inline-block;
			}
		}

		.legend {
			span {
				position: relative;
				margin-right: 40px;

				&::before {
					position: absolute;
					top: 5px;
					left: -20px;
					width: 10px;
					height: 10px;
					border-radius: 50%;
					content: '';
				}

				&.l1::before {
					background-color: #B8E986;
				}

				&.l2::before {
					background-color: #D63803;
				}
			}
		}
	}

	.visit-info {
		.no-data {
			height: 100%;
			padding: 0;
			font-size: 16px;
			align-items: center;
			justify-content: center;
			display: flex;
		}

		.visit-header {
			margin-bottom: 10px;
			padding-bottom: 10px;
			border-bottom: 1px solid #f0f0f0;
			display: flex;
			justify-content: space-between;

			.page {
				i {
					padding: 0 5px;
					cursor: pointer;
				}
			}
		}
	}

	.follow-info {
		margin-bottom: 20px;

		.el-card-header {
			.more {
				span {
					margin: 0 10px;
				}
			}
		}

		.item {
			padding: 10px 0;

			.lbl {
				margin-bottom: 8px;
				font-size: 16px;
			}

			.content {
				line-height: 1.8em;
				white-space: pre-wrap;
			}
		}
	}

	.follow-form {
		.action {
			margin-bottom: 20px;
			padding-top: 20px;
			text-align: center;

			.el-button {
				margin: 0 30px;
			}
		}
	}

	.content-pre-wrap {
		white-space: pre-wrap;

		.el-form-item__label {
			line-height: 1.8em;
		}

		.el-form-item__content {
			line-height: 1.8em;
		}
	}
}
</style>
